import { render } from "./Space-IN.vue?vue&type=template&id=5adc77be&scoped=true"
import script from "./Space-IN.vue?vue&type=script&lang=js"
export * from "./Space-IN.vue?vue&type=script&lang=js"

import "./Space-IN.vue?vue&type=style&index=0&id=5adc77be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5adc77be"]])

export default __exports__